import { forwardRef } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import {
  BoldItalicUnderlineToggles,
  CodeToggle,
  ListsToggle,
  MDXEditor,
  type MDXEditorMethods,
  type MDXEditorProps,
  Separator,
  UndoRedo,
  codeBlockPlugin,
  codeMirrorPlugin,
  headingsPlugin,
  listsPlugin,
  markdownShortcutPlugin,
  toolbarPlugin,
} from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';

import './editor-styles.css';

export type MarkdownEditorProps = MDXEditorProps;

export const MarkdownEditor = forwardRef<MDXEditorMethods, MarkdownEditorProps>(
  (
    { plugins = [], className, contentEditableClassName, placeholder, ...rest },
    ref
  ) => {
    return (
      <MDXEditor
        ref={ref}
        plugins={[
          headingsPlugin(),
          markdownShortcutPlugin(),
          listsPlugin(),
          codeBlockPlugin({ defaultCodeBlockLanguage: 'txt' }),
          codeMirrorPlugin({
            codeBlockLanguages: {
              txt: 'Text',
              js: 'JavaScript',
              ts: 'TypeScript',
              css: 'CSS',
              python: 'Python',
              java: 'Java',
              json: 'JSON',
            },
          }),
          toolbarPlugin({
            toolbarContents: () => (
              <Flex h={9}>
                <Box data-disabled as={UndoRedo} />
                <Separator />
                <Box data-disabled as={BoldItalicUnderlineToggles} />
                <Separator />
                <Box as={ListsToggle} options={['number', 'bullet']} />
                <Separator />
                <Box as={CodeToggle} />
              </Flex>
            ),
          }),
          ...plugins,
        ]}
        className={`mdx-editor ${className}`}
        contentEditableClassName={`mdx-editor-content ${contentEditableClassName}`}
        placeholder={placeholder}
        {...rest}
      />
    );
  }
);

MarkdownEditor.displayName = 'MarkdownEditor';
